import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import {
    UtilService,
    WaypointContract,
} from '@polaris-customerweb/sharedcomponents.core';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Waypoint } from '@polaris-customerweb/sharedcomponents.user-content';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class WaypointPhotoResource {
    private baseUrl: string;

    constructor(
        private configService: ConfigService,
        private http: HttpClient,
        private routingHelpersService: RoutingHelpersService,
        private utilService: UtilService
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.rideCommand,
            'v2/waypoints'
        );
    }

    uploadPhoto(waypointId: string, file: File): Observable<Waypoint> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            waypointId,
            'photo'
        );
        const data = this.utilService.xformObjectToFormPost({
            fileUpload: file,
        });

        return this.http
            .post<WaypointContract>(url, data)
            .pipe(
                map(
                    (dto: WaypointContract) =>
                        new Waypoint(dto, this.configService.appSku)
                )
            );
    }

    deletePhoto(waypointId: string): Observable<void> {
        const url = this.routingHelpersService.combineUrl(
            this.baseUrl,
            waypointId,
            'photo'
        );
        return this.http.delete<undefined>(url);
    }
}
